import React, { SyntheticEvent } from 'react';
import { FiltersWrapper } from './styles';
import { autocompleteRender } from '../../../../utils/autocompleteRenders';
import { Autocomplete } from '@mui/material';
import { IGlobalMake, TReviewOption } from '../../../../store/reducers/globalVehicles/types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';

import { reviewOptions } from '../../../../utils/constants';
import { useAutocompleteStyles } from '../../../../hooks/styling/useAutocompleteStyles';
import { renderChipTagsWithoutOptionObject } from '../../Transportations/EditTransportationModal/layouts/ChipTagRender';

type TProps = {
  onMakesChange: (e: SyntheticEvent, option: IGlobalMake[]) => void;
  onStatusChange: (e: SyntheticEvent, option: TReviewOption | null) => void;
  isLoading: boolean;
  selectedMake: IGlobalMake[];
  selectedStatus: TReviewOption | null;
  disabled: boolean;
};

const Filters: React.FC<TProps> = ({
  onMakesChange,
  onStatusChange,
  isLoading,
  selectedMake,
  selectedStatus,
  disabled,
}) => {
  const { allMakesOptions } = useSelector((state: RootState) => state.globalVehicles);
  const { classes } = useAutocompleteStyles();
  return (
    <FiltersWrapper>
      <Autocomplete
        multiple
        classes={classes}
        style={{ width: 465 }}
        options={allMakesOptions}
        loading={isLoading}
        value={selectedMake}
        disabled={disabled}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        getOptionLabel={o => o.vinMake}
        disableCloseOnSelect
        renderTags={(selected, getTagProps) =>
          renderChipTagsWithoutOptionObject(
            selected.map(item => item.vinMake),
            getTagProps,
            400
          )
        }
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            flexWrap: 'nowrap',
          },
        }}
        onChange={onMakesChange}
        renderInput={autocompleteRender({
          label: 'Makes',
          placeholder: selectedMake?.length ? '' : 'Not selected',
        })}
      />
      <Autocomplete
        style={{ width: 180 }}
        loading={isLoading}
        disabled={isLoading || disabled}
        value={selectedStatus}
        options={reviewOptions}
        isOptionEqualToValue={(o, v) => o === v}
        getOptionLabel={o => o}
        onChange={onStatusChange}
        renderInput={autocompleteRender({
          label: 'Review Status',
          placeholder: 'Not selected',
        })}
      />
    </FiltersWrapper>
  );
};

export default Filters;
